module.exports = __webpack_public_path__ + "Lato-Hairline.db15ac7981b2d2897d1a";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-Hairline.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Hairline.ttf
// module chunks = styles